import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

// Initial state
const initialState = {
  filters: {
    modalFiltersRules: undefined,
    modalConditions: undefined,
  },
};

// Actual Slice
export const logisticsSlice = createSlice({
  name: 'logistics',
  initialState,
  reducers: {
    filtersModalChangeLogisticsSuccess: (state, { payload }) => {
      state.filters.modalConditions = payload;
      if (!payload?.rules?.length) {
        state.filters.modalFiltersRules = undefined;
      }
    },
    filtersModalRulesLogisticsChangeSuccess: (state, { payload }) => {
      state.filters.modalFiltersRules = payload;
    },
    resetModalChangeLogisticsSuccess: (state) => {
      state.filters.modalConditions = null;
      state.filters.modalFiltersRules = null;
    },
    // Special reducer for hydrating the state. Special case for next-redux-wrapper
    extraReducers: {
      [HYDRATE]: (state, action) => {
        return {
          ...state,
          ...action.payload.errors,
        };
      },
    },
  },
});

export const {
  filtersModalChangeLogisticsSuccess,
  filtersModalRulesLogisticsChangeSuccess,
  resetModalChangeLogisticsSuccess,
} = logisticsSlice.actions;

export const filtersModalConditionLogisticsChange = (rules) => {
  return (dispatch) => {
    dispatch(filtersModalChangeLogisticsSuccess(rules));
  };
};

export const filtersModalRulesLogisticsChange = (rules) => {
  return (dispatch) => {
    dispatch(filtersModalRulesLogisticsChangeSuccess(rules));
  };
};

export const resetModalLogisticsChange = () => {
  return (dispatch) => {
    dispatch(resetModalChangeLogisticsSuccess());
  };
};

export const selectLogisticsState = (state) => state.logistics;

export default logisticsSlice.reducer;
